import { render, staticRenderFns } from "./VipDialog.vue?vue&type=template&id=d56c29fe&scoped=true"
import script from "./VipDialog.vue?vue&type=script&lang=js"
export * from "./VipDialog.vue?vue&type=script&lang=js"
import style0 from "./VipDialog.vue?vue&type=style&index=0&id=d56c29fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56c29fe",
  null
  
)

export default component.exports